import { createContext, useContext, type ReactNode } from 'react'

export type TripFormMode = 'create' | 'edit'
export type TripFormVariant = 'driver' | 'carrier'

type CreateTripContextValue = {
  onExit: () => void | Promise<void>
  mode: TripFormMode
  variant: TripFormVariant
  editingTripId?: number
  onSaved?: () => void
}

const CreateTripContext = createContext<CreateTripContextValue | null>(null)

export const CreateTripProvider = ({
  onExit,
  mode = 'create',
  variant = 'driver',
  editingTripId,
  onSaved,
  children,
}: {
  onExit: () => void | Promise<void>
  mode?: TripFormMode
  variant?: TripFormVariant
  editingTripId?: number
  onSaved?: () => void
  children: ReactNode
}) => (
  <CreateTripContext.Provider value={{ onExit, mode, variant, editingTripId, onSaved }}>
    {children}
  </CreateTripContext.Provider>
)

export const useCreateTripExit = () => {
  const ctx = useContext(CreateTripContext)
  return ctx?.onExit
}

export const useTripFormMode = () => {
  const ctx = useContext(CreateTripContext)
  return ctx?.mode ?? 'create'
}

export const useEditingTripId = () => {
  const ctx = useContext(CreateTripContext)
  return ctx?.editingTripId
}

export const useTripFormOnSaved = () => {
  const ctx = useContext(CreateTripContext)
  return ctx?.onSaved
}

export const useTripFormVariant = () => {
  const ctx = useContext(CreateTripContext)
  return ctx?.variant ?? 'driver'
}
